<template>
  <div>
    <elastic-block-store-monitor-search
      :ebsColumns="tableColumnsChecked"
    ></elastic-block-store-monitor-search>
    <!-- 动态表头 -->
    <Checkbox-group
      v-model="tableColumnsChecked"
      @on-change="changeTableColumns"
    >
      <Collapse>
        <Panel name="1">
          <span style="font-size:13px;font-weight:600;">{{
            $t("alarms.common.dynamicHeader")
          }}</span>
          <template slot="content">
            <Row>
              <Col span="24">
                <Row>
                  <Col span="6">
                    <Checkbox label="accountTypeName">{{
                      $t("alarms.common.accountType")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="accountName">{{
                      $t("alarms.common.accountName")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="volumeAwsId">{{
                      $t("alarms.disk.diskId")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="name">{{
                      $t("alarms.disk.name")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="capacity">{{
                      $t("alarms.disk.capacity")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="type">{{
                      $t("alarms.disk.type")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="iopsName">{{
                      $t("alarms.disk.iops")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="encrypted">{{
                      $t("alarms.disk.encrypted")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="region">{{
                      $t("alarms.disk.region")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="stateName">{{
                      $t("alarms.disk.state")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="volumeNotAttachedAlertRuleStatistics">{{
                      $t("alarms.disk.volumeNotAttached")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox
                      label="volumeReadWritePRIOPSAlertRuleStatistics"
                      >{{ $t("alarms.disk.volumeReadWritePRIOPS") }}</Checkbox
                    >
                  </Col>
                  <Col span="6">
                    <Checkbox label="volumeReadWriteOpsAlertRuleStatistics">{{
                      $t("alarms.disk.volumeReadWriteOps")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="readIOPSAlertRuleStatistics">{{
                      $t("alarms.disk.readIOPS")
                    }}</Checkbox>
                  </Col>
                  <Col span="6">
                    <Checkbox label="writeIOPSAlertRuleStatistics">{{
                      $t("alarms.disk.writeIOPS")
                    }}</Checkbox>
                  </Col>
                </Row>
              </Col>
            </Row>
          </template>
        </Panel>
      </Collapse>
    </Checkbox-group>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableEBSDate"
      style="width: 100.1%;"
      border
    >
      <template slot-scope="{ row, index }" slot="delete">
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            @click="EBSDelmodal = true"
            v-hasPermission="['monitor:elasticBlockStoreMonitor:delete']"
            >{{ $t("alarms.common.delete") }}</Button
          >
          <Button
            type="info"
            size="small"
            @click="rowClick(row)"
            v-hasPermission="['monitor:elasticBlockStoreMonitor:detail']"
            >{{ $t("alarms.common.details") }}</Button
          >
        </span>
      </template>
    </Table>
    <!-- 删除卷模式框 -->
    <Modal v-model="EBSDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ EBSInstanceId }}
          {{ $t("alarms.common.allWarningRules") }}？
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeEBS()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import ElasticBlockStoreMonitorSearch from "../ebs/ElasticBlockStoreMonitorSearch";
var tableEBSVue = {};
export default {
  name: "TableElasticBlockStore",
  components: {
    ElasticBlockStoreMonitorSearch
  },
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      EBSDelmodal: false,
      isDisable: false,
      modal_loading: false,
      val: "",
      region: "",
      EBSInstanceId: "",
      tableColumnsChecked: [
        "accountTypeName",
        "accountName",
        "volumeAwsId",
        "name",
        "capacity",
        "type",
        "iopsName",
        "encrypted",
        "region",
        "stateName"
      ], //动态表头
      columns: [],
      tableEBSDate: []
    };
  },
  beforeCreate: function() {
    tableEBSVue = this;
  },
  created() {
    // 获取ElasticBlockStoreMonitorSearch里面的搜索内容
    eventBus.$on("volumeId", function(val) {
      tableEBSVue.volumeId = val;
    });
    // 获取ElasticBlockStoreMonitorSearch里面的搜索内容
    eventBus.$on("region", function(val) {
      tableEBSVue.region = val;
    });
    // 获取ElasticComputeCloudMonitorSearch里面的搜索内容
    eventBus.$on("accountName", function(val) {
      tableEBSVue.accountName = val;
    });
    // 获取ElasticComputeCloudMonitorSearch里面的搜索内容
    eventBus.$on("accountType", function(val) {
      tableEBSVue.accountType = val;
    });
    // 获取ElasticComputeCloudMonitorSearch里面的搜索内容
    eventBus.$on("volumeName", function(val) {
      tableEBSVue.volumeName = val;
    });
    // 获取ElasticComputeCloudMonitorSearch里面的搜索内容
    eventBus.$on("companyId", function(val) {
      tableEBSVue.companyId = val;
    });
  },
  mounted: function() {
    // tableEBSVue.getEBSData();
    tableEBSVue.changeTableColumns();
  },
  methods: {
    showAll: function() {
      tableEBSVue.getEBSData();
    },
    // 分页显示数据
    /****************************************************/
    getEBSData: function() {
      //卷列表分页
      this.$api.volume
        .pageVolume({
          companyId: tableEBSVue.companyId,
          volumeAwsId: tableEBSVue.volumeId,
          name: tableEBSVue.volumeName,
          accountType: tableEBSVue.accountType,
          accountName: tableEBSVue.accountName,
          region: tableEBSVue.region,
          pageNum: this.current,
          pageSize: this.pageSize,
          monitorModule: 11
        })
        .then(res => {
          this.tableEBSDate = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      if (tableEBSVue.volumeId != undefined) {
        tableEBSVue.volumeId = "";
      }
      this.current = current;
      tableEBSVue.getEBSData();
    },
    changeSize: function(pageSize) {
      if (tableEBSVue.volumeId != undefined) {
        tableEBSVue.volumeId = "";
      }
      this.pageSize = pageSize;
      tableEBSVue.getEBSData();
    },
    // 销毁volumeIdSearchName
    beforeDestroy: function() {
      eventBus.$off("volumeIdSearchName");
      eventBus.$off("regionName");
    },
    // 删除
    /****************************************************/
    doDelete: function(index) {
      this.lineIndex = index;
      this.EBSInstanceId = this.tableEBSDate[index].volumeAwsId;
    },
    removeEBS: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //卷删除
      this.$api.volume
        .deleteVolume("id", this.tableEBSDate[lineIndex].id)
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableEBSVue.getEBSData();
            this.isDisable = false;
            this.modal_loading = false;
            this.EBSDelmodal = false;
            this.$Message.success("删除成功");
          }, 1000);
        });
    },
    /************************* 动态表头 *******************************/
    //动态表头
    getColumns() {
      const tableColumnList = {
        accountTypeName: {
          title: this.$t("alarms.common.accountType"),
          fixed: "left",
          width: 120,
          key: "accountTypeName"
        },
        accountName: {
          title: this.$t("alarms.common.accountName"),
          width: 150,
          key: "accountName"
        },
        volumeAwsId: {
          title: this.$t("alarms.disk.diskId"),
          width: 150,
          key: "volumeAwsId"
        },
        name: {
          title: this.$t("alarms.disk.name"),
          width: 150,
          key: "name"
        },
        capacity: {
          title: this.$t("alarms.disk.capacity"),
          width: 150,
          key: "capacity"
        },
        type: {
          title: this.$t("alarms.disk.type"),
          width: 150,
          key: "type"
        },
        iopsName: {
          title: this.$t("alarms.disk.iops"),
          width: 150,
          key: "iopsName"
        },
        volumeNotAttachedAlertRuleStatistics: {
          title: this.$t("alarms.disk.volumeNotAttached"),
          width: 150,
          key: "volumeNotAttachedAlertRuleStatistics",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.$emit(
                      "changeCurrentTab",
                      params.row,
                      params.row.volumeNotAttachedMonitorIndex
                    );
                  }
                }
              },
              params.row.volumeNotAttachedAlertRuleStatistics
            );
          }
        },
        volumeReadWritePRIOPSAlertRuleStatistics: {
          title: this.$t("alarms.disk.volumeReadWritePRIOPS"),
          width: 150,
          key: "volumeReadWritePRIOPSAlertRuleStatistics",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.$emit(
                      "changeCurrentTab",
                      params.row,
                      params.row.volumeReadWritePRIOPSMonitorIndex
                    );
                  }
                }
              },
              params.row.volumeReadWritePRIOPSAlertRuleStatistics
            );
          }
        },
        volumeReadWriteOpsAlertRuleStatistics: {
          title: this.$t("alarms.disk.volumeReadWriteOps"),
          width: 150,
          key: "volumeReadWriteOpsAlertRuleStatistics",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.$emit(
                      "changeCurrentTab",
                      params.row,
                      params.row.volumeReadWriteOpsMonitorIndex
                    );
                  }
                }
              },
              params.row.volumeReadWriteOpsAlertRuleStatistics
            );
          }
        },
        readIOPSAlertRuleStatistics: {
          title: this.$t("alarms.disk.readIOPS"),
          width: 150,
          key: "readIOPSAlertRuleStatistics",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.$emit(
                      "changeCurrentTab",
                      params.row,
                      params.row.readIOPSMonitorIndex
                    );
                  }
                }
              },
              params.row.readIOPSAlertRuleStatistics
            );
          }
        },
        writeIOPSAlertRuleStatistics: {
          title: this.$t("alarms.disk.writeIOPS"),
          width: 150,
          key: "writeIOPSAlertRuleStatistics",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.$emit(
                      "changeCurrentTab",
                      params.row,
                      params.row.writeIOPSMonitorIndex
                    );
                  }
                }
              },
              params.row.writeIOPSAlertRuleStatistics
            );
          }
        },
        encrypted: {
          title: this.$t("alarms.disk.encrypted"),
          width: 150,
          key: "encrypted"
        },
        region: {
          title: this.$t("alarms.disk.region"),
          width: 150,
          key: "region"
        },
        stateName: {
          title: this.$t("alarms.disk.state"),
          width: 150,
          key: "stateName"
        },
        action: {
          title: this.$t("common.operation"),
          slot: "delete",
          fixed: "right",
          width: 150
        }
      };
      let data = [tableColumnList.action];
      this.tableColumnsChecked.forEach(col => data.push(tableColumnList[col]));
      return data;
    },
    changeTableColumns() {
      this.columns = this.getColumns();
    },
    // 单击行
    /****************************************************/
    rowClick: function(row) {
      this.$router.push({
        path: "/monitor/elasticBlockStoreDetail/",
        query: {
          id: row.id,
          accountId: row.accountId,
          volumeAwsId: row.volumeAwsId,
          instanceId: row.instanceId,
          region: row.region,
          accountTypeName: row.accountTypeName,
          accountName: row.accountName,
          name: row.name,
          awsZone: row.awsZone
        }
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/ebs/TableElasticBlockStore.vue